<template>
  <div>
    <v-form>
      <v-layout row="" wrap>

        <v-flex xs12 sm6 md6>
          <!-- <tarihcomp :etiket="'Fatura Tarihi'" :aktifmi="durum" v-bind:defaultvalue="'ok'" :tabindex="'50'"
            v-bind:value="val.FaturaBilgileri.FaturaTarihi" v-model="val.FaturaBilgileri.FaturaTarihi"></tarihcomp> -->
        </v-flex>

        <v-flex xs12 sm6 md6>
          <!-- <tarihcomp :etiket="'E-Arşiv Ödeme Tarihi'" v-model="val.FaturaBilgileri.EfaturaBilgileri.OdemeTarihi"
            v-bind:defaultvalue="'ok'" :tabindex="'51'" v-bind:value="val.FaturaBilgileri.EfaturaBilgileri.OdemeTarihi"></tarihcomp> -->
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-text-field hide-details="" tabindex="52" disabled="" v-model="val.FaturaBilgileri.FaturaSeri" label="Fatura Seri"></v-text-field>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-text-field hide-details="" tabindex="53" disabled="" v-model="val.FaturaBilgileri.FaturaNo" label="Fatura No"></v-text-field>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-select :items="gonderimsekli" v-model="val.FaturaBilgileri.EfaturaBilgileri.GonderimSekli" tabindex="54"
            hide-details="" clearable item-text="text" item-value="value" label="E-Arşiv Gönderim Şekli"></v-select>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-select :items="odemesekli" tabindex="55" hide-details="" clearable item-text="text" item-value="value"
            v-model="val.FaturaBilgileri.EfaturaBilgileri.InternetSatis" label="E-Arşiv İnternet Satış"></v-select>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <webadresicomp :tabdeger="'56'" v-model="val.FaturaBilgileri.EfaturaBilgileri.WebAdresi"></webadresicomp>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <v-select :items="odemesekli1" v-model="val.FaturaBilgileri.EfaturaBilgileri.OdemeSekli" tabindex="57"
            hide-details="" clearable item-text="text" item-value="value" label="E-Arşiv Ödeme Şekli"></v-select>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <odemesekillericomp :tabdeger="'58'" v-model="val.FaturaBilgileri.EfaturaBilgileri.OdemeSekliAciklama">
          </odemesekillericomp>
        </v-flex>

        <v-flex xs12 sm6 md6>
          <odemearacicomp :tabdeger="'59'" v-model="val.FaturaBilgileri.EfaturaBilgileri.OdemeAraci"> </odemearacicomp>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field tabindex="60" v-model="val.FaturaBilgileri.KdvKod" hide-details="" label="KDV Kodu"></v-text-field>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-text-field tabindex="61" v-model="val.FaturaBilgileri.IstinaKod" hide-details="" label="İstisna Kodu"></v-text-field>
        </v-flex>

      </v-layout>
    </v-form>
  </div>
</template>

<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihim'
  import webadresicomp from "@/components/app/bilet/partpage/webadresicomp.vue"
  import odemesekillericomp from "@/components/app/bilet/partpage/odemesekillericomp.vue"
  import odemearacicomp from "@/components/app/bilet/partpage/odemearacicomp.vue"



  export default {
    name: 'fatura',
    data() {
      return {
        doviztipi: [],
        efaturatipi: '',
        parainputdeger: 0,
        komisyontip: [{
          text: 'K-Komisyonlu',
          value: 'K'
        }, {
          text: 'P-Komisyonsuz',
          value: 'N'
        }],
        efaturatipi: [{
            text: 'Ticari',
            value: '0'
          },
          {
            text: 'Temel',
            value: '1'
          },
          {
            text: 'İhracat',
            value: '2'
          }
        ],
        gonderimsekli: [{
            text: 'Kağıt',
            value: 0
          },
          {
            text: 'Elektronik',
            value: 1
          }
        ],
        odemesekli: [{
            text: 'Normal Satış',
            value: 0
          },
          {
            text: 'İnternet Satış',
            value: 1
          }
        ],
        odemesekli1: [{
            text: 'Kredi-Banka Kartı',
            value: '0'
          },
          {
            text: 'EFT-Havale',
            value: '1'
          },
          {
            text: 'Kapıda Ödeme',
            value: '2'
          },
          {
            text: 'Ödeme Aracısı',
            value: '3'
          },
          {
            text: 'Diğer',
            value: '4'
          }
        ],

        odemearaci: [],


      }
    },
    props: ['value', 'tabindex', 'name', 'id', 'durum', 'aktif', 'tabdeger'],
    computed: {
      val: {
        get: function () {

          return this.value;
        },
        set: function (newValue) {
          this.$emit('input', newValue)
        },
      }
    },
    beforeMount: beforeMount,
    components: {
      tarihcomp,
      webadresicomp,
      odemesekillericomp,
      odemearacicomp
    },

    methods: {
      faturadialogac() {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));
        this.faturadialog = true
        var params = {
          SirketKodu: credentials.SirketKodu,
          FaturaTip: 'D',
          DovizliFatura: false,
          HatTipi: this.Bilet.GenelBilgileri.UcusTipi
        }

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceMainTableList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.dizaynsec = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceMainTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceMainTableList'
            this.snackbar = true
          }
        })

        this.$http.post(auth.API_URL + 'api/TicketInvoice/InvoiceXsltTableList', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.xsltitems = response.body
        }, (response) => {
          if (response.status === 0) {
            this.progress = false
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-InvoiceXsltTableList'
            this.snackbar = true
          }
        })
      }

    },
  }

  function beforeMount() {


  }
</script>